var tokenInfo
const mock = process.env.REACT_APP_MOCK_TOKEN_AUTH0;

async function getM2MToken() {
  const url = `https://${process.env.REACT_APP_AUTH0_DOMAIN}/oauth/token`;
  const body = {
    grant_type: 'client_credentials',
    client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
    client_secret: process.env.REACT_APP_AUTH0_SECRET_ID,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE
  };

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  };

  const response = await fetch(url, requestOptions);
  const data = await response.json();

  return data;
}

const getToken = async () => {
  if (mock) {
    return mock
  }

  const token = getTokenFromCache()
  if (token) {
    return token
  }

  const oauth_response = await getM2MToken()  
  saveTokenWithTTL(oauth_response)
  return oauth_response.access_token;
};

function saveTokenWithTTL(tokenData) {
  const ahora = Date.now();
  const ttl = tokenData.expires_in * 1000; // Convertir de segundos a milisegundos

  tokenInfo = {
    token: tokenData.access_token,
    expiracion: ahora + ttl
  };
}

function getTokenFromCache() {
  if (!tokenInfo) {
    return null; // No hay token almacenado
  }

  const ahora = Date.now();

  if (tokenInfo.expiracion < ahora) {
    tokenInfo = null
    return null; // El token expiró
  }

  return tokenInfo.token; // El token es válido y aún no expiró
}


export default getToken